export enum DownloadableReportStatus {
    IDLE = 'idle',
    DOWNLOADING = 'downloading',
    DOWNLOADED = 'downloaded',
    ERROR = 'error'
}
